import { render, staticRenderFns } from "./FixedContainer.vue?vue&type=template&id=63ebda8b&scoped=true&"
import script from "./FixedContainer.vue?vue&type=script&lang=js&"
export * from "./FixedContainer.vue?vue&type=script&lang=js&"
import style0 from "./FixedContainer.vue?vue&type=style&index=0&id=63ebda8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ebda8b",
  null
  
)

export default component.exports